import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import "simple-datatables/dist/style.css";
import {
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  Combobox,
  ComboboxButton,
  ComboboxInput,
  ComboboxOption,
  ComboboxOptions,
  Label,
} from "@headlessui/react";
import { Routes, Route, useNavigate, useLocation ,Outlet} from "react-router-dom";
import {
  updateTabPath,
  updateTabStates
} from "../../store/actions";
import { v4 as uuidv4 } from "uuid";
import { Auth } from "aws-amplify";
import { getActiveSurveyProgress } from "../../services/surveyJobInitialize";
import { XMarkIcon, EyeIcon,  LockClosedIcon,   ArrowPathIcon} from "@heroicons/react/24/outline";

import Button from "../layout/button";
export default function QRobotProgress() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const themeMode = useSelector((state) => state.themeMode);
  // const currentSurvey = useSelector((state) => state.currentSurvey);
  const organizations = useSelector((state) => state.organizations);
  const topMenuTabs = useSelector((state) => state.topMenuTabs);

  // const themeMode = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.themeMode;
  const currentSurvey = topMenuTabs.tabs.find(
    (tab) => tab.id === topMenuTabs.activeTab
  ).states.currentSurvey;
  // const organizations = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.organizations;

  // console.log(organization)
  let [token, setToken] = useState("");

  const [open, setOpen] = useState(false);
  const [editMenuopen, setEditMenuOpen] = useState(false);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [filterSearchTerm, setFilterSearchTerm] = useState("");
  const [selectedLabel, setSelectedLabel] = useState(""); // Store selected label
  const [clearFilter, setClearFilter] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [isSearchBarOpen, setIsSearchBarOpen] = useState(false);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const itemsPerPage = 3;
  const [filteredData, setFilteredData] = useState([]);
  const [filteredSearchData, setFilteredSearchData] = useState([]);
  const [sortedData, setSortedData] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });
  const [query, setQuery] = useState("");
  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [selectedOrganization, setSelectedOrganization] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);
  const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });
  const filterMenuRef = useRef(null);
  const [addUserInfoMenuShow,setAddUserInfoMenuShow]=useState(false)
  const [selectedFunction, setSelectedFunction] = useState("");
  const [allowMenuOpen, setAllowMenuOpen] = useState(false);
  const [success,setSuccess]=useState(false);
  const [error,setError]=useState(false)
  const [infoText,setInfoText]=useState("")
  const [isLoading,setIsLoading] =useState(false)
  const handleClickOutside = (event) => {
    if (
      filterMenuRef.current &&
      !filterMenuRef.current.contains(event.target)
    ) {
      // Hide the search bar but keep the sortOptions visible
      setShowSearchBar(false);
      setFilterSearchTerm("");
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  async function checkAuth() {
    // window.location.reload();
    try {
      const cognitoUser = await Auth.currentAuthenticatedUser();
      const currentSession = await Auth.currentSession();
      await cognitoUser.refreshSession(
        currentSession.refreshToken,
        (err, session) => {
          const { idToken, refreshToken, accessToken } = session;
          getToken(idToken.jwtToken);
        }
      );
    } catch (e) {
      // console.log('Unable to refresh Token', e);
    }
  }

  useEffect(() => {
    getToken();
  }, []);

  async function getToken(token) {

      const currentSession = await Auth.currentSession();
      setToken(currentSession.idToken.jwtToken);
    
  }

  useEffect(() => {
    if (token.length > 0) {
        getSurveyProgress()

      if (selectedFunction === "saveUser") {
        // saveUser();
      }
      setSelectedFunction("");
    }
  }, [token]);

 
  async function getSurveyProgress(){
      const result = await getActiveSurveyProgress(token,"qrobot");
      setData(result);  

        setIsLoading(false)

       
  }
  const handleRightClick = (event, rowIndex, row) => {
    event.preventDefault();
    setSelectedRow(row);
    setMenuPosition({ x: event.pageX, y: event.pageY });
    setButtonDisabled(false);
    setName(row.first_name);
    setLastName(row.last_name)
    setEmail(row.email);
    setSelectedOrganization("");
    setEditMenuOpen(true);
  };


  const toggleAddEmployeMenuOpen = () => {
    setOpen((prevState) => !prevState);
  };
  const togglePopup = () => {
    setIsPopupVisible(!isPopupVisible);
  };
  const toggleSearchBar = () => {
    setIsSearchBarOpen(!isSearchBarOpen);
  };
  const sortOptions = [
    { name: "Survey Name", href: "#", current: false },
    { name: "Progress", href: "#", current: false },
    { name: "Status", href: "#", current: false },
    {name:"Avarage", href:"#",curret:false},
    { name: "View", href: "#", current: true },
  ];
  const [data, setData] = useState([]);


  const [switchStates, setSwitchStates] = useState(
    sortOptions.reduce((acc, option) => {
      acc[option.name] = true; // Tüm switch'ler başlangıçta kapalı
      return acc;
    }, {})
  );
  const handleSwitchToggle = (name) => {
    setSwitchStates((prev) => ({
      ...prev,
      [name]: !prev[name], // Geçerli switch'in durumunu tersine çevir
    }));
  };
  const handleMenuItemClick = (label) => {
    setSelectedLabel(label); // Set selected label for filtering
    setShowSearchBar(true); // Show the search bar
  };
  useEffect(() => {
    console.log( data)
    // if (data.length()>0){
    const filtered = data.filter((row) =>
      row.survey_name?.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredData(filtered);
  }, [data, searchTerm]);

  useEffect(() => {
    const filteredSearch = filteredData.filter((row) => {
      if (!selectedLabel || !filterSearchTerm) return true; // Eğer filtre seçilmemişse tüm veriyi göster
      if (selectedLabel.toLowerCase() === "Survey Name") {
        const surveyName = row.surveyName.toLowerCase();
        return surveyName.includes(filterSearchTerm.toLowerCase());
      } else if (selectedLabel.toLowerCase() === "Status") {
        const organization = row.status.toLowerCase();
        return organization.includes(filterSearchTerm.toLowerCase());
      } else {
        return row[selectedLabel.toLowerCase()]
          ?.toLowerCase()
          .includes(filterSearchTerm.toLowerCase()); // Seçilen label ve arama terimine göre filtreleme
      }
    });
    setFilteredSearchData(filteredSearch);
  }, [filteredData, selectedLabel, filterSearchTerm]);
  useEffect(() => {
    if (sortConfig.key) {
      const sorted = [...filteredSearchData].sort((a, b) => {
        // Sayılar ve metinler için karşılaştırmayı türüne göre yap
        let valA = a[sortConfig.key];
        let valB = b[sortConfig.key];
        if (sortConfig.key === "surveyName") {
          valA = a.survey_name
          valB = b.survey_name
        }
        if (sortConfig.key === "status") {
          valA = a.status
          valB = b.status
        }
        // Verinin türüne göre karşılaştırma yap
        if (typeof valA === "string" && typeof valB === "string") {
          // String karşılaştırması (case-insensitive)
          const aLower = valA.toLowerCase();
          const bLower = valB.toLowerCase();

          if (aLower < bLower) {
            return sortConfig.direction === "ascending" ? -1 : 1;
          }
          if (aLower > bLower) {
            return sortConfig.direction === "ascending" ? 1 : -1;
          }
        } else if (typeof valA === "number" && typeof valB === "number") {
          // Sayısal karşılaştırma
          if (valA < valB) {
            return sortConfig.direction === "ascending" ? -1 : 1;
          }
          if (valA > valB) {
            return sortConfig.direction === "ascending" ? 1 : -1;
          }
        }
        return 0;
      });
      setSortedData(sorted);
      console.log("sprted",sorted)
    } else {
        console.log(filteredSearchData)
      setSortedData(filteredSearchData);
    }
  }, [filteredSearchData, sortConfig]);

  const handleSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };




  const switchMenuParentRef = useRef(null);
  const switchMenuChildRef = useRef(null);
  useEffect(() => {
    const adjustChildPosition = () => {
      if (switchMenuParentRef.current && switchMenuChildRef.current) {
        const parentRect = switchMenuParentRef.current.getBoundingClientRect();

        switchMenuChildRef.current.style.marginTop = `${
          parentRect.height + 5
        }px`;
      }
    };
    // İlk pozisyonu ayarla
    adjustChildPosition();

    // Dinamik değişiklikler için dinleyiciler ekle
    window.addEventListener("resize", adjustChildPosition);
    window.addEventListener("scroll", adjustChildPosition);

    return () => {
      window.removeEventListener("resize", adjustChildPosition);
      window.removeEventListener("scroll", adjustChildPosition);
    };
  }, []);
  useEffect(() => {
    // Automatically close the dialog after 5 seconds
    const timer = setTimeout(() => {
      setAddUserInfoMenuShow(false);
    }, 3000); // 5000 ms = 5 seconds

    // Cleanup the timer when the component unmounts or dialog closes
    return () => clearTimeout(timer);
  }, [addUserInfoMenuShow, addUserInfoMenuShow]);
    const viewSurvey = (item, page = "summary") => {
      const targetUrl = `/surveys/${item}/summary`;
      // Only dispatch and navigate if the current survey is different
      if (location.pathname !== targetUrl) {
        dispatch(updateTabStates(topMenuTabs.activeTab, 'surveyDetailSelectedTab', 'Summary'));
        dispatch(updateTabPath(topMenuTabs.activeTab, 'Summary', `/surveys/${item}/summary`));
        navigate(`/surveys/${item}/` + page);
      }
      else {
        return;
      }
    };
const CircleProgress = ({ value, size = 32, stroke = 4 }) => {
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (value / 100) * circumference;

  return (
    <svg width={size} height={size} className="block">
      {/* background */}
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        stroke="#e5e7eb"
        strokeWidth={stroke}
        fill="none"
      />
      {/* progress */}
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        stroke="#3b82f6"
        strokeWidth={stroke}
        fill="none"
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        strokeLinecap="round"
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
      />
    </svg>
  );
};

  return (
    <div
      className={`flex  flex-col h-full w-full justify-between ${
        themeMode === "dark" ? "bg-[#1a1a28]  border-gray-200" : "bg-[#fbfbfc]"
      }`}
    >
      <div className="flex items-center justify-between flex-shrink-0 min-w-0 h-[50px] px-12 py-0">
        <div className="flex mr-2 gap-[0.25rem]  z-1">
          <Menu as="div" className=" inline-block text-left  py-3 relative ">
            <div>
              <MenuButton
                className={`flex items-center self-stretch p-0  h-[1.5rem] lg:h-[2rem] min-w-8  rounded-md shadow-inner cursor-text  ${
                  themeMode === "dark"
                    ? "bg-white-02"
                    : "bg-black-02 shadow-[0_0_0_1px_rgba(0,0,0,0.09)]"
                } `}
              >
                <div
                  className={`hulyButton font-medium-14 h-[1.5rem] w-[1.5rem] lg:h-[2rem] lg:w-[2rem] border rounded-[0.375rem] cursor-pointer flex justify-center  items-center ${
                    themeMode === "dark"
                      ? "border-[#d1d5de0a] bg-[#d1d5de0d] hover:bg-[#d1d5de0a]"
                      : "border-[#1725471a] bg-[#1725470d] hover:bg-[#1725471a]"
                  }`}
                  data-id="btn-viewSetting"
                >
                  <div
                    className={`icon no-gap  inline-flex justify-center  items-center  ${
                      themeMode === "dark" ? "text-[#ffffff]" : "text-[#000]"
                    }`}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="size-4 lg:size-5"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M10.5 6h9.75M10.5 6a1.5 1.5 0 1 1-3 0m3 0a1.5 1.5 0 1 0-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-9.75 0h9.75"
                      />
                    </svg>
                  </div>
                </div>
              </MenuButton>
            </div>

            <MenuItems
              transition
              className={` absolute left-1 z-[1000] mt-2 w-40 origin-top-right rounded-md shadow-2xl ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in  border-solid border-[1px] ${
                themeMode === "dark"
                  ? " bg-[#2a2939] border-white-09 shadow-theme-popup-shadow "
                  : "bg-[#FFFFFF] border-black-09 shadow-black-2-shadow"
              }`}
            >
              <div className="py-1 relative">
                {sortOptions.map((option, index) => (
                  <div
                    key={`${option.name}-${index}`}
                    className="mb-4 relative"
                  >
                    <div
                      className={`flex-shrink-0 relative flex justify-between px-2 py-1 min-w-0 min-h-[2.25rem] text-left rounded-md ${
                        themeMode === "dark"
                          ? "hover:bg-[#333240] text-white"
                          : "hover:bg-[#EBEBEB] text-black"
                      }`}
                    >
                      <label
                        htmlFor={`switch-${index}`}
                        className={`ms-3 text-sm font-medium relative ${
                          themeMode === "dark"
                            ? "text-[#f7f8f8]"
                            : "text-[#131416]"
                        }`}
                      >
                        {option.name}
                      </label>

                      <div className="relative inline-block w-11 h-5">
                        <input
                          id={`switch3-${index}`}
                          type="checkbox"
                          className="peer appearance-none w-11 h-5 bg-[rgba(120,120,128,0.32)] rounded-full checked:bg-[#205dc2] cursor-pointer transition-colors duration-300"
                          checked={switchStates[option.name]} // Durumdan gelen değer
                          onChange={() => handleSwitchToggle(option.name)} // Tıklamayı işle
                        />
                        <label
                          htmlFor={`switch3-${index}`}
                          className="absolute top-0 left-0 w-5 h-5 bg-white rounded-full border border-slate-300 shadow-sm transition-transform duration-300 peer-checked:translate-x-6 peer-checked:border-slate-800 cursor-pointer"
                        ></label>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </MenuItems>
          </Menu>
        </div>
        <div className="flex flex-end gap-2 ">
          <label
            className={`flex items-center self-stretch p-0 pr-1 h-[1.5rem]  lg:h-[2rem] min-w-8  rounded-md shadow-inner cursor-text transition-all max-w-8 focus-within:max-w-[15rem] focus-within:pr-1 focus-within:p-0.25 active:max-w-[15rem] active:pr-1 active:p-0.25 ${
              themeMode === "dark"
                ? "bg-white-02"
                : "bg-black-02 shadow-[0_0_0_1px_rgba(0,0,0,0.09)]"
            }`}
          >
            <div
              className={`flex items-center justify-center flex-shrink-0 p-0 bg-transparent border-none outline-none cursor-pointer rounded-md h-8 w-8  mr-1 focus-within:cursor-text ${
                themeMode === "dark" ? "text-white" : "text-[#0f121a]"
              }`}
            >
              <svg
                className="w-[1rem] h-[1rem] "
                fill="currentColor"
                viewBox="0 0 16 16"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  file-rule="evenodd"
                  clipRule="evenodd"
                  d="M10.7241 10.0168L14.3535 13.6465C14.5488 13.8417 14.5488 14.1583 14.3535 14.3536C14.1602 14.5469 13.8478 14.5488 13.6522 14.3592L10.017 10.7238C8.9277 11.6312 7.5305 12.0836 6.11608 11.9871C4.70165 11.8905 3.37891 11.2524 2.423 10.2054C1.4671 9.15843 0.951637 7.78323 0.983845 6.36588C1.01605 4.94853 1.59345 3.59816 2.59593 2.59568C3.5984 1.59321 4.94877 1.01581 6.36612 0.983601C7.78347 0.951393 9.15867 1.46686 10.2057 2.42276C11.2526 3.37866 11.8908 4.70141 11.9873 6.11583C12.0839 7.53026 11.6314 8.92745 10.7241 10.0168ZM2.75851 3.99981C2.26404 4.73983 2.00012 5.60986 2.00012 6.49987C2.00144 7.69294 2.47597 8.83677 3.3196 9.68039C4.16323 10.524 5.30705 10.9986 6.50012 10.9999C7.39013 10.9999 8.26016 10.736 9.00018 10.2415C9.7402 9.74702 10.317 9.04422 10.6576 8.22195C10.9982 7.39968 11.0873 6.49488 10.9137 5.62197C10.74 4.74905 10.3114 3.94723 9.6821 3.31789C9.05276 2.68856 8.25094 2.25997 7.37802 2.08634C6.50511 1.91271 5.60031 2.00182 4.77804 2.34242C3.95578 2.68301 3.25297 3.25979 2.75851 3.99981Z"
                ></path>
              </svg>
            </div>
            <input
              type="text"
              className={`mr-3 p-0 w-full h-full ${
                themeMode === "dark"
                  ? "text-white placeholder:text-white"
                  : "text-[#0f121a] placeholder:text-[#0f121a]"
              } caret-[#2a59d6] bg-transparent border-none outline-none appearance-none`}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search"
              autoComplete="off"
              spellCheck="false"
            />
          </label>
          <div className="flex items-center hidden">
            <Menu
              as="div"
              className="relative inline-block text-left z-5"
              ref={filterMenuRef}
            >
              <div>
                <MenuButton
                  className={`flex items-center self-stretch p-0 pr-1 h-[1.5rem] lg:h-[2rem] min-w-8  rounded-md shadow-inner cursor-text  ${
                    themeMode === "dark"
                      ? "bg-white-02"
                      : "bg-black-02 shadow-[0_0_0_1px_rgba(0,0,0,0.09)]"
                  } `}
                >
                  {filterSearchTerm !== "" ? (
                    <div
                      onClick={() => {
                        setFilterSearchTerm("");
                        setShowSearchBar(false);
                      }} // Reset search term to empty string
                      className={`px-3 py-1 text-sm border  flex justify-jenter items-center rounded-[0.375rem] border-solid gap-1 ${
                        themeMode === "dark"
                          ? " bg-white-02 border-white-09 hover:bg-white-08 hover:text-[#fff] text-white-8"
                          : " bg-black-02 border-black-09 hover:bg-black-08 hover:text-[#000] text-black-8"
                      }`}
                    >
                      <div
                        className={`btn-icon pointer-events-none ${
                          themeMode === "dark" ? "text-white-8" : "text-black-8"
                        }`}
                      >
                        <svg
                          className="svg-small  w-[.8rem] h-[.8rem]"
                          fill="currentColor"
                          viewBox="0 0 16 16"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M8.7,8l4.6-4.6c0.2-0.2,0.2-0.5,0-0.7s-0.5-0.2-0.7,0L8,7.3L3.4,2.6c-0.2-0.2-0.5-0.2-0.7,0s-0.2,0.5,0,0.7L7.3,8l-4.6,4.6c-0.2,0.2-0.2,0.5,0,0.7c0.1,0.1,0.2,0.1,0.4,0.1s0.3,0,0.4-0.1L8,8.7l4.6,4.6c0.1,0.1,0.2,0.1,0.4,0.1s0.3,0,0.4-0.1c0.2-0.2,0.2-0.5,0-0.7L8.7,8z"></path>
                        </svg>
                      </div>
                      <span className="overflow-label label disabled pointer-events-none whitespace-nowrap break-all text-ellipsis overflow-hidden min-w-0">
                        Clear filter
                      </span>
                    </div>
                  ) : (
                    <div
                      className={`flex items-center justify-center gap-3 p-0 px-3 bg-transparent border border-transparent rounded-md text-sm  min-w-[1.375rem] whitespace-nowrap transition-all duration-150 hover:bg-black-200 hover:border-black-900  ${
                        themeMode === "dark"
                          ? "hover:text-[#fff] text-white-8"
                          : "hover:text-[#000] text-black-8"
                      }`}
                      type="button"
                      onClick={() => {
                        setFilterSearchTerm("");
                        setShowSearchBar(false);
                        togglePopup();
                      }}
                    >
                      <div className="pointer-events-none">
                        <svg
                          className="w-4 h-4"
                          fill="currentColor"
                          viewBox="0 0 32 32"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M29.9,4.1c-0.1-0.4-0.4-0.8-0.7-1.1c-0.3-0.3-0.7-0.5-1.1-0.7c-0.1,0-0.2-0.1-0.3-0.1H4.2c-0.1,0-0.2,0-0.3,0.1C3.5,2.5,3.1,2.7,2.8,3C2.5,3.3,2.3,3.7,2.1,4.1C2,4.5,2,5,2,5.4c0.1,0.4,0.2,0.8,0.5,1.2c0,0,0.1,0.1,0.1,0.1l8.8,9.7v6.9c0,0.3,0.1,0.6,0.4,0.8l7.3,5.4c0.2,0.1,0.4,0.2,0.6,0.2c0.2,0,0.3,0,0.4-0.1c0.3-0.2,0.6-0.5,0.6-0.9V16.4l8.8-9.7c0,0,0.1-0.1,0.1-0.1c0.2-0.4,0.4-0.8,0.5-1.2C30,5,30,4.5,29.9,4.1z M27.9,5.4l-9,9.9c-0.2,0.2-0.3,0.4-0.3,0.7v10.7l-5.3-3.9V16c0-0.2-0.1-0.5-0.3-0.7l-9-9.9C4.1,5.3,4,5.2,4,5.1C4,5,4,4.9,4,4.8c0-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.1-0.1,0.2-0.1h23.2c0.1,0,0.1,0.1,0.2,0.1c0.1,0.1,0.2,0.2,0.2,0.3C28,4.9,28,5,28,5.1C28,5.2,27.9,5.3,27.9,5.4z"></path>
                        </svg>
                      </div>
                      <span className="overflow-hidden text-ellipsis whitespace-nowrap text-gray-500 cursor-not-allowed">
                        Filter
                      </span>
                    </div>
                  )}
                </MenuButton>
              </div>

              <MenuItems
                transition
                className={`absolute right-0 z-1 mt-2 w-40 origin-top-right rounded-md shadow-2xl ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in  border-solid border-[1px] ${
                  themeMode === "dark"
                    ? " bg-[#2a2939] border-white-09 shadow-theme-popup-shadow "
                    : "bg-[#FFFFFF] border-black-09 shadow-black-2-shadow"
                }`}
              >
                <div className="py-1">
                  {showSearchBar ? (
                    <div className="px-4 py-2">
                      <input
                        type="text"
                        placeholder="Search..."
                        value={filterSearchTerm}
                        onChange={(e) => setFilterSearchTerm(e.target.value)}
                        className={`w-full px-2 py-1 border rounded-md  ${
                          themeMode === "dark"
                            ? " bg-[#2a2939] border-white-09 shadow-theme-popup-shadow  placeholder:text-white-6 text-white"
                            : "bg-[#FFFFFF] border-black-09 shadow-black-2-shadow placeholder:text-black-6 text-black-6"
                        }`}
                      />
                    </div>
                  ) : (
                    sortOptions.map((option) => (
                      <MenuItem key={option.name}>
                        <a
                          href={option.href}
                          className={`${
                            themeMode === "dark"
                              ? "text-[#fff] hover:bg-[#333240]"
                              : "text-[#000] hover:bg-[#EBEBEB]"
                          } block px-4 py-2 text-sm data-[focus]:outline-none`}
                          onClick={(e) => {
                            e.preventDefault(); // Varsayılan bağlantı davranışını durdurur
                            e.stopPropagation(); // Tıklamanın menüyü kapatmasını engeller
                            handleMenuItemClick(option.name);
                          }}
                        >
                          {option.name}
                        </a>
                      </MenuItem>
                    ))
                  )}
                </div>
              </MenuItems>
            </Menu>
          </div>
          <div className="flex items-center space-x-2 print:hidden">
            <Button
  text="Refresh"
  onClick={()=>{setIsLoading(true);getSurveyProgress()}}
  themeMode={themeMode}
  icon={
    <ArrowPathIcon
      className={`h-4 w-4 ${isLoading ? "animate-spin" : ""}`}
    />
  }
  iconPosition="left"
  className="px-3 h-6 lg:h-8 rounded-lg text-[0.8125rem] flex items-center"
/>
          </div>
        </div>
      </div>
      <div className="overflow-x-auto flex-1 ">
        <table
          className={`min-w-full border border-b border-solid border-[1px]  table-fixed  ${
            themeMode === "dark"
              ? " bg-[#1C1C29] border-white-06"
              : "bg-[#efeff2] border-black-06"
          }`}
        >
          <thead
            className={`border border-b border-t-0 border-r-0 border-l-0 border-solid border-[1px] px-8 ${
              themeMode === "dark"
                ? "bg-[#1C1C29] border-white-06"
                : "bg-[#efeff2] border-black-06"
            }`}
          >
            <tr className="">
              {switchStates["Survey Name"] && (
                <th
                  onClick={() => handleSort("surveyName")}
                  className={`h-12 w-1/5 p-2.5 pl-12 font-semibold text-xs tracking-tight text-left uppercase custom-shadow-light ${
                    themeMode === "dark"
                      ? "text-white text-opacity-60"
                      : "text-gray-600"
                  }`}
                >
                  <span className="flex justify-start gap-2">
                    Name{" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      className="size-4"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M3 7.5 7.5 3m0 0L12 7.5M7.5 3v13.5m13.5 0L16.5 21m0 0L12 16.5m4.5 4.5V7.5"
                      />
                    </svg>
                  </span>
                </th>
              )}
              {switchStates["Status"] && (
                <th
                  onClick={() => handleSort("status")}
                  className={`p-2.5 pl-6 h-12 font-semibold text-xs tracking-tight text-left uppercase custom-shadow-light w-1/5 ${
                    themeMode === "dark"
                      ? "text-white text-opacity-60"
                      : "text-gray-600"
                  }`}
                >
                  <span className="flex justify-start gap-2">
                    Status
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      className="size-4"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M3 7.5 7.5 3m0 0L12 7.5M7.5 3v13.5m13.5 0L16.5 21m0 0L12 16.5m4.5 4.5V7.5"
                      />
                    </svg>
                  </span>
                </th>
              )}
              {switchStates["Progress"] && (
                <th
                  onClick={() => handleSort("progress")}
                  className={`p-2.5 pl-6 h-12 font-semibold text-xs tracking-tight text-left uppercase custom-shadow-light  ${
                    themeMode === "dark"
                      ? "text-white text-opacity-60"
                      : "text-gray-600"
                  }`}
                >
                  <span className="flex justify-start gap-2">
                    Progress
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      className="size-4"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M3 7.5 7.5 3m0 0L12 7.5M7.5 3v13.5m13.5 0L16.5 21m0 0L12 16.5m4.5 4.5V7.5"
                      />
                    </svg>
                  </span>
                </th>
              )}
               {switchStates["Avarage"] && (
                <th
                  
                  className={`p-2.5 pl-6 h-12 font-semibold text-xs tracking-tight text-left uppercase custom-shadow-light  ${
                    themeMode === "dark"
                      ? "text-white text-opacity-60"
                      : "text-gray-600"
                  }`}
                >
                  <span className="flex justify-start gap-2">
                    Avarage creation time
                   
                  </span>
                </th>
              )}
              <th
                  
                  className={`p-2.5 pl-6 h-12 font-semibold text-xs tracking-tight text-left uppercase custom-shadow-light  ${
                    themeMode === "dark"
                      ? "text-white text-opacity-60"
                      : "text-gray-600"
                  }`}
                >
                  <span className="flex justify-start gap-2">
                    View
                  
                  </span>
                </th>
            </tr>
          </thead>
          <tbody
            className={`${
              themeMode === "dark" ? "bg-[#21212F]" : "bg-[#f4f4f6]"
            }`}
          >
            {sortedData.map((row, index) => (
              <tr
                key={`${row.id}-${index}`}
                onContextMenu={(e) => handleRightClick(e, index, row)}
                className={` h-13 border-b  ${
                  themeMode === "dark"
                    ? "text-[#FFF] hover:bg-[#282834] border-[rgba(255,255,255,0.06)]"
                    : "hover:bg-[#E8E8E9] border-[rgba(0,0,0,0.06)]"
                }`}
              >
                {switchStates["Survey Name"] && (
                  <td className="p-2.5 pl-12 text-left text-sm   ">
                    {row.survey_name}
                  </td>
                )}
                {switchStates["Status"] && (
                  <td className="p-2.5 pl-6 text-left text-sm   ">
                    {row.status}
                  </td>
                )}
                {switchStates["Progress"] && (
                  <td className="p-2.5 pl-6 text-left text-sm   ">
                    <div className="relative w-8 h-8">
                      <CircleProgress value={row.progress} />
                      <span className="absolute inset-0 flex items-center justify-center text-[10px] font-medium">
                        {row.progress}%
                      </span>
                    </div>

                  </td>
                )}
                {switchStates["Avarage"] && (
                  <td className="p-2.5 pl-6 text-left text-sm   ">
                    <div className="flex">
                    
                      {Math.floor(row.avg_duration_seconds)}s
                    </div>
                  </td>
                )}
               <td
                  className={`p-2.5 pl-6 text-left text-sm
                    ${row.progress === 100
                      ? "cursor-pointer text-blue-600 hover:text-blue-800"
                      : "cursor-not-allowed text-gray-400"}
                  `}
                  onClick={() => {
                    if (row.progress === 100) {
                      viewSurvey(row.survey_id);
                    }
                  }}
                >
                  {row.progress === 100 ? (
                    <EyeIcon className="w-4 h-4" />
                  ) : (
                    <LockClosedIcon className="w-4 h-4" />
                  )}
                </td>
               </tr>
            ))}
          </tbody>
        </table>
      </div>

    </div>
  );
}
